$(".customslider-sectioninner").slick({ 
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_9_c8c2e648-10d1-4608-8693-02636d69c7ec.png?v=1730886836"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_9_c8c2e648-10d1-4608-8693-02636d69c7ec.png?v=1730886836"></div>',
  
  dots: false,
  infinite: false,  
  speed: 1200
});
$(".realhitslider").slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-006" viewBox="0 0 24 24"><g> <path d="M16.736,3.417c0,0.169-0.059,0.319-0.176,0.449l-8.32,8.301l8.32,8.301c0.117,0.13,0.176,0.28,0.176,0.449s-0.059,0.319-0.176,0.449c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.149-0.075-0.215-0.127l-8.75-8.75c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449l8.75-8.75c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176C16.677,3.098,16.736,3.248,16.736,3.417z"></path></g></svg></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24"> <g><path d="M6.708,20.917c0-0.169,0.059-0.319,0.176-0.449l8.32-8.301l-8.32-8.301c-0.117-0.13-0.176-0.28-0.176-0.449 c0-0.169,0.059-0.319,0.176-0.449c0.13-0.117,0.279-0.176,0.449-0.176c0.169,0,0.318,0.059,0.449,0.176l8.75,8.75c0.117,0.13,0.176,0.28,0.176,0.449c0,0.169-0.059,0.319-0.176,0.449l-8.75,8.75c-0.065,0.052-0.137,0.094-0.215,0.127 c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.15-0.075-0.215-0.127C6.767,21.236,6.708,21.086,6.708,20.917z"></path></g></svg></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".bestsellet-mainnav").slick({
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-006" viewBox="0 0 24 24"><g> <path d="M16.736,3.417c0,0.169-0.059,0.319-0.176,0.449l-8.32,8.301l8.32,8.301c0.117,0.13,0.176,0.28,0.176,0.449s-0.059,0.319-0.176,0.449c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.149-0.075-0.215-0.127l-8.75-8.75c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449l8.75-8.75c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176C16.677,3.098,16.736,3.248,16.736,3.417z"></path></g></svg></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24"> <g><path d="M6.708,20.917c0-0.169,0.059-0.319,0.176-0.449l8.32-8.301l-8.32-8.301c-0.117-0.13-0.176-0.28-0.176-0.449 c0-0.169,0.059-0.319,0.176-0.449c0.13-0.117,0.279-0.176,0.449-0.176c0.169,0,0.318,0.059,0.449,0.176l8.75,8.75c0.117,0.13,0.176,0.28,0.176,0.449c0,0.169-0.059,0.319-0.176,0.449l-8.75,8.75c-0.065,0.052-0.137,0.094-0.215,0.127 c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.15-0.075-0.215-0.127C6.767,21.236,6.708,21.086,6.708,20.917z"></path></g></svg></div>',
});

$(".Feature-CollectionNew ul").slick({
  dots: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector.png?v=1723102849"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_1.png?v=1723102848"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1.6,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".Philosophy-Sectionslider").slick({
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector.png?v=1723102849"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_1.png?v=1723102848"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".MustHave-SectionSlide").slick({
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_9.png?v=1723212852"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_10.png?v=1723212852"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".logo_innersection").slick({
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 3000,
  pauseOnHover: false,
  cssEase: "linear",
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".TalkSection-Slide").slick({
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  prevArrow:
    '<div class="arrowsec prev-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_9.png?v=1723212852"></div>',
  nextArrow:
    '<div class="arrowsec next-arrowsec"><img src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_10.png?v=1723212852"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },

    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
}); 

